<div class="tag-input-container">
  <!-- Add Tag Button -->
  <div class="add-tag-button-wrapper" *ngIf="!readonly && canAddMoreTags && !showInput">
    <lds-button
      iconBefore="add"
      appearance="default"
      size="sm"
      (onClick)="toggleInputVisibility()">
      Add tag
    </lds-button>
  </div>

  <!-- Input Field -->
  <div class="tag-input-field" *ngIf="!readonly && canAddMoreTags && showInput">
    <div class="typeahead-wrapper" #typeaheadWrapper (keyup.enter)="onEnterPressed()" (focusout)="onFocusOut()">
      <spark-shared-form-typeahead-field
        #typeaheadField
        name="tagSearch"
        [placeholder]="placeholder"
        [formControl]="tagSearchControl"
        [isAsync]="true"
        [dataSource$]="tagDataSource$"
        [waitMs]="300"
        [minLength]="0"
        [maxLength]="50"
        [allowManualEntry]="true">
      </spark-shared-form-typeahead-field>
    </div>
  </div>

  <!-- Existing Tags -->
  <div class="tags-list" *ngIf="tags.length > 0">
    <div class="tag-pill" *ngFor="let tag of tags; trackBy: trackByTagId">
      <span class="tag-name">{{ tag.tagName }}</span>
      <button
        *ngIf="!readonly"
        class="tag-remove"
        type="button"
        (click)="removeTag(tag, $event)"
        [attr.aria-label]="'Remove tag ' + tag.tagName"
        title="Remove tag">
        <lds-icon name="close" size="xs" appearance="inherit"></lds-icon>
      </button>
    </div>
  </div>

  <!-- Empty State for Read-Only -->
  <div class="tags-empty-state" *ngIf="showEmptyState && readonly && tags.length === 0">
    <small class="empty-text">No tags</small>
  </div>
</div>

